function isTextSelected(document) {
  return !!document.getSelection().toString();
}

export { isTextSelected };
